import { Spin } from "antd";

export const Loading = () => {
    return (
      <div className="loading-container">
        <Spin spinning={true} tip="Procesando, por favor espera..." size="large" />
      </div>
    );
  };